export const SITE = {
  name: "Empower Legacy Finance",
  short: "Empower Legacy Finance",
  phone: "0404 123 038",
  phoneRaw: "0404123038",
  phoneTel: "tel:+61404123038",
  email: "nelson@empowerlegacyfinance.com.au",
  emailHref: "mailto:nelson@empowerlegacyfinance.com.au",
  region: "Australia-wide",
  tagline: "Mortgage broking built around your legacy.",
};

export const NAV = [
  { label: "Services", href: "/#services" },
  { label: "Process", href: "/#process" },
  { label: "About", href: "/#about" },
  { label: "Blog", href: "/blog" },
  { label: "FAQ", href: "/#faq" },
  { label: "Contact", href: "/#contact" },
];

export const SERVICES = [
  {
    key: "home",
    title: "Home Loans",
    blurb:
      "Owner-occupier loans tailored to your goals — from first home buyers to upgraders.",
    bullets: ["Sharp variable & fixed rates", "Pre-approval guidance", "Stamp duty support"],
    image:
      "https://images.unsplash.com/photo-1666004095305-300183c896ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhdXN0cmFsaWFuJTIwaG9tZSUyMGV4dGVyaW9yJTIwc3VubGlnaHR8ZW58MHx8fHwxNzc4MDYyMjU2fDA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    key: "fhb",
    title: "First Home Buyers",
    blurb: "Navigate FHOG, FHSS and the First Home Guarantee with a broker on your side.",
    bullets: ["Government scheme reviews", "Deposit strategy"],
    image:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-1 lg:row-span-1",
  },
  {
    key: "investment",
    title: "Investment & Commercial",
    blurb: "Build a portfolio with structures designed for cash flow, equity and growth.",
    bullets: ["Interest-only options", "Commercial finance", "Asset finance"],
    image:
      "https://images.unsplash.com/photo-1581345187185-8bd48eb6dca6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhdXN0cmFsaWFuJTIwaG9tZSUyMGV4dGVyaW9yJTIwc3VubGlnaHR8ZW58MHx8fHwxNzc4MDYyMjU2fDA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-2 lg:row-span-1",
  },
  {
    key: "refinance",
    title: "Refinancing",
    blurb: "Review your current loan, unlock equity and switch to a sharper deal.",
    bullets: ["Rate reviews", "Cashback offers", "Debt consolidation"],
    image:
      "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-1 lg:row-span-1",
  },
  {
    key: "smsf",
    title: "Self-Employed & SMSF",
    blurb: "Specialist lending for sole traders, contractors and SMSF property purchases.",
    bullets: ["Alt-doc loans", "SMSF residential & commercial"],
    image:
      "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-1 lg:row-span-1",
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Discovery",
    desc: "A 15-minute call to understand your goals, timeline and current financial position.",
  },
  {
    n: "02",
    title: "Strategy",
    desc: "We compare 40+ Australian lenders and design a structure that maximises your borrowing power.",
  },
  {
    n: "03",
    title: "Approval",
    desc: "We package, submit and chase the application — keeping you informed every step.",
  },
  {
    n: "04",
    title: "Settlement",
    desc: "Keys in hand. We stay across rate reviews and refinance opportunities for life.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Got us into our first home in Brisbane months earlier than we thought possible. The broker walked us through the FHOG and made everything feel calm.",
    name: "Aarav & Priya",
    detail: "First Home Buyers · QLD",
  },
  {
    quote:
      "Refinanced two investment properties and saved over $7,400 a year. Honest advice, no jargon, no fuss.",
    name: "Michael T.",
    detail: "Investor · NSW",
  },
  {
    quote:
      "As a contractor I was getting knocked back everywhere. Empower Legacy Finance structured it properly and got us approved.",
    name: "Sophie L.",
    detail: "Self-Employed · VIC",
  },
];

export const FAQS = [
  {
    q: "How much does a mortgage broker cost?",
    a: "Our service is free for most residential loans — we're paid a commission by the lender once your loan settles. We always disclose this upfront so there are no surprises.",
  },
  {
    q: "How many lenders do you compare?",
    a: "We compare loans from 40+ Australian lenders, including the major banks, second-tier banks, credit unions and specialist non-bank lenders.",
  },
  {
    q: "Can you help if I'm self-employed or a contractor?",
    a: "Absolutely. We work with lenders who understand variable income, ABN holders and contractors. We can often use one year of financials or alt-doc options.",
  },
  {
    q: "How long does it take to get approved?",
    a: "Pre-approval usually takes 2–5 business days once we have your documents. Full approval timing depends on the lender — we'll give you a realistic timeline upfront.",
  },
  {
    q: "Do you service all of Australia?",
    a: "Yes. We work with clients right across Australia — most of the process runs over phone, email and secure document upload.",
  },
];

export const LOAN_TYPES = [
  "Home Loan",
  "First Home Buyer",
  "Investment Loan",
  "Refinance",
  "Commercial Loan",
  "Self-Employed / SMSF",
  "Not sure yet",
];
